import React from 'react';
import { ArrowRight, Lock } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export function CTAButton({
  text = 'QUIERO DEJAR DE IMPROVISAR',
  className = ''
}: CTAButtonProps) {
  return <div className="flex flex-col items-center w-full sm:w-auto" data-id="element-73">
      <a href="https://bienestardigital.click/cart/add?id=43120004464729&quantity=1" className={`relative inline-flex items-center justify-center gap-2 bg-brand-coral hover:bg-[#c96b43] text-white font-bold py-4 px-8 rounded-full text-lg md:text-xl transition-all duration-300 hover:scale-105 shadow-[0_0_20px_rgba(239,118,116,0.5)] hover:shadow-[0_0_30px_rgba(239,118,116,0.7)] w-full sm:w-auto overflow-hidden group ${className}`} data-id="element-74">
        <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:animate-[shimmer_1.5s_infinite] transition-transform duration-700" data-id="element-75"></div>
        <span className="relative z-10 flex items-center gap-2" data-id="element-76">
          {text}
          <ArrowRight className="w-5 h-5" data-id="element-77" />
        </span>
      </a>
      <div className="flex items-center gap-1.5 mt-3 text-xs md:text-sm font-medium text-brand-charcoal/70" data-id="element-78">
        <Lock className="w-3.5 h-3.5" data-id="element-79" />
        <span data-id="element-80">Pago seguro • Acceso inmediato</span>
      </div>
    </div>;
}